import { render, staticRenderFns } from "./CollectionFollowResultPerformance.vue?vue&type=template&id=764e193c&scoped=true&"
import script from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js&"
export * from "./CollectionFollowResultPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFollowResultPerformance.vue?vue&type=style&index=0&id=764e193c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e193c",
  null
  
)

export default component.exports